import TopRichText from './topRichText'

export default TopRichText